import { render } from "./ProviderAddHeader.vue?vue&type=template&id=4460a484"
import script from "./ProviderAddHeader.vue?vue&type=script&lang=js"
export * from "./ProviderAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__